<template>
  <div class="page">
    <SiteHero
      pageTitle="Registration"
      pageDescription="Registration page for Irvine classes"
    />
  
    <div class="page-content">
      <div class="max-w-6xl mx-auto px-4 py-12">
        <div class="grid grid-cols-1 gap-8">
          <div class="mb-16">
            <div class="flex flex-col gap-8 items-center mb-8">
              <div class="w-full h-[calc(100vh-400px)] min-h-[600px]">
                <iframe
                  src='https://my.rhinofit.ca/store/index/fbda3810'
                  title="Empire Training Grounds Registration Form"
                  style='width: 100%; height: 100%;'
                  class="rounded-lg"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>
  
<script>
import SiteFooter from '../components/Footer/SiteFooter.vue';
import SiteHero from '../components/Hero/SiteHero.vue';
import '../assets/styles/page.css';

export default {
  name: 'RegisterIrvine',
  components: {
    SiteFooter,
    SiteHero
  }
};
</script>